import { useContext } from "react";

import AuthContext from "./contexts/sessionContext";
import { BrowserRouter } from "react-router-dom";

import AdmRoutes from "./routes/adm.routes";
import AnalistRoutes from "./routes/analist.routes";
import TypistRoutes from "./routes/typist.routes";
import Login from "./routes/auth.routes";

function Routes() {
	const { signed, user } = useContext(AuthContext);

	return (
		<BrowserRouter>
			{(!signed && <Login />) ||
				(user.role === 0 && <AdmRoutes />) ||
				(user.role === 1 && <AnalistRoutes />) ||
				(user.role === 2 && <TypistRoutes />)}
		</BrowserRouter>
	);
}

export default Routes;
